import DOMPurify from "dompurify";

type TrustedIframeProps = {
  src: string;
  width?: string;
  height?: string;
  allow?: string;
  allowFullScreen?: boolean;
  frameBorder?: string;
  title?: string;
};

export const parseTrustedIframe = (
  rawEmbedCode?: string,
): TrustedIframeProps | null => {
  if (typeof rawEmbedCode !== "string" || !rawEmbedCode.trim()) return null;

  const sanitizedContent = DOMPurify.sanitize(rawEmbedCode, {
    ALLOWED_TAGS: ["iframe"],
    ALLOWED_ATTR: [
      "src",
      "width",
      "height",
      "allow",
      "allowfullscreen",
      "frameborder",
      "title",
    ],
    FORBID_TAGS: ["script", "style", "form"],
    FORBID_ATTR: [
      "onerror",
      "onload",
      "onclick",
      "onmouseover",
      "onfocus",
      "onmouseenter",
    ],
  });
  const parsedDocument = new DOMParser().parseFromString(
    sanitizedContent,
    "text/html",
  );
  const bodyChildren = Array.from(parsedDocument.body.children);
  if (bodyChildren.length !== 1 || bodyChildren[0]?.tagName !== "IFRAME")
    return null;

  const iframe = bodyChildren[0];
  const src = iframe.getAttribute("src");
  if (!src) return null;
  try {
    if (new URL(src).protocol !== "https:") return null;
  } catch {
    return null;
  }

  return {
    src: new URL(src).toString(),
    width: iframe.getAttribute("width") ?? undefined,
    height: iframe.getAttribute("height") ?? undefined,
    allow: iframe.getAttribute("allow") ?? undefined,
    allowFullScreen: iframe.hasAttribute("allowfullscreen") || undefined,
    frameBorder: iframe.getAttribute("frameborder") ?? undefined,
    title: iframe.getAttribute("title") ?? undefined,
  };
};
